import { render } from "./AccountsFundedManually.vue?vue&type=template&id=96adfd68&scoped=true"
import script from "./AccountsFundedManually.vue?vue&type=script&lang=js"
export * from "./AccountsFundedManually.vue?vue&type=script&lang=js"

import "./AccountsFundedManually.vue?vue&type=style&index=0&id=96adfd68&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96adfd68"]])

export default __exports__